import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ETotalCountItem, IMeeting, IMessage } from '../models/message.model';
import { IBaseTableResult } from '../models/table.model';
import { IInboxCount } from '../models/inbox';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  constructor(private http: HttpClient) {
  }


  markAsNotSpam(id: number): Observable<any> {
    return this.http.put(environment.apiUrl + `/v1/messages/${id}`, {
      is_spam: false,
    });
  }

  viewMessage(
    idMessage: number,
    lock?: boolean,
    unlock?: boolean,
    page = 1,
  ): Observable<IBaseTableResult<IMessage>> {
    const pageUri = 'page=' + page;
    if (lock) {
      return this.http.get<IBaseTableResult<IMessage>>(
        environment.apiUrl + `/v1/messages/${idMessage}?lock=true&${pageUri}`,
      );
    } else if (unlock) {
      return this.http.get<IBaseTableResult<IMessage>>(
        environment.apiUrl + `/v1/messages/${idMessage}?unlock=true&${pageUri}`,
      );
    }
    return this.http.get<IBaseTableResult<IMessage>>(
      environment.apiUrl + `/v1/messages/${idMessage}?${pageUri}`,
    );
  }

  viewMeeting(id): Observable<any> {
    return this.http.get<IBaseTableResult<IMeeting>>(
      environment.apiUrl + `/v1/meetings/${id}`,
    );
  }

  getInboxCount(): Observable<IInboxCount> {
    return this.http.get<IInboxCount>(
      environment.apiUrl + '/v1/messages/inbox',
    );
  }

  getTotalMessagesCount(filter?: ETotalCountItem): Observable<{
    total_sent: number;
  }> {
    return this.http.get<{
      total_sent: number;
    }>(environment.apiUrl + '/v1/messages/total', {
      params: {
        filter: filter || null,
      },
    });
  }

  updateMeeting(meeting): Observable<any> {
    return this.http.put<IBaseTableResult<IMeeting>>(
      environment.apiUrl + `/v1/meetings/${meeting.meeting_id}`,
      { ...meeting },
    );
  }

  restoreMeeting(meetingId): Observable<any> {
    return this.http.put<IBaseTableResult<IMeeting>>(
      environment.apiUrl + `/v1/meetings/${meetingId}/restore`,
      {},
    );
  }

  deleteMeeting(id): Observable<any> {
    return this.http.delete<IBaseTableResult<IMeeting>>(
      environment.apiUrl + `/v1/meetings/${id}`,
    );
  }

  addProduct(meeting, product) {
    return this.http.post(
      environment.apiUrl + `/v1/meetings/${meeting.meeting_id}/products`,
      { ...product },
    );
  }

  updateProduct(meeting, product) {
    return this.http.put(
      environment.apiUrl +
      `/v1/meetings/${meeting.meeting_id}/products/${product.id}`,
      { ...product },
    );
  }

  deleteProduct(meeting, product) {
    return this.http.delete<IBaseTableResult<IMeeting>>(
      environment.apiUrl +
      `/v1/meetings/${meeting.meeting_id}/products/${product.id}`,
    );
  }

  setSpam(id, spam): Observable<any> {
    // make it spam
    return this.http.put(environment.apiUrl + `/v1/messages/${id}`, {
      is_spam: spam,
    });
  }

  deleteSpam(): Observable<any> {
    return this.http.delete(environment.apiUrl + `/v1/messages/spam`);
  }

  readStatus(id): Observable<any> {
    return this.http.get(environment.apiUrl + `/v1/messages/${id}/read`);
  }

  sendTestMessage(
    recipients: string,
    message: string,
    subject: string,
    greeting?: string,
    name?: string,
  ): Observable<{
    success: boolean;
  }> {
    return this.http.post<{
      success: boolean;
    }>(environment.apiUrl + '/v1/messages/sample-email', {
      to: recipients,
      subject,
      message,
      greeting,
      name,
    });
  }

  sendOnetimeMessage(
    contacts: number[],
    message: string,
    subject: string,
    greeting: string,
    vip: boolean = false,
  ): Observable<{
    success: boolean;
  }> {
    return this.http.post<{
      success: boolean;
    }>(environment.apiUrl + '/v1/messages/onetime', {
      contacts,
      message,
      subject,
      greeting,
      vip,
    });
  }

  sendEscalateReplay(messageId: number): Observable<{
    success: boolean;
    message_id: number;
  }> {
    return this.http.get<{
      success: boolean;
      message_id: number;
    }>(environment.apiUrl + `/v1/messages/${messageId}/escalate`);
  }

  sendReleaseReplay(
    messageId: number,
    note: string,
    notifyManager: boolean,
  ): Observable<{
    success: boolean;
    message_id: number;
  }> {
    return this.http.put<{
      success: boolean;
      message_id: number;
    }>(environment.apiUrl + `/v1/messages/${messageId}/release`, {
      note,
      notify_manager: notifyManager,
    });
  }

  deleteUnknownEmail(id?: number): Observable<{
    success: boolean;
  }> {
    if (!id) {
      return this.http.delete<{
        success: boolean;
      }>(environment.apiUrl + `/v1/admin/unknown_emails`);
    }

    return this.http.delete<{
      success: boolean;
    }>(environment.apiUrl + `/v1/admin/unknown_emails/${id}`);
  }
}
